import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withNamespaces } from "react-i18next";
import { Card, Form, Button, Spinner } from "react-bootstrap";
import { closeIframesScreens } from "~/containers/SidebarContainer/util";
import "~/assets/css/icons.css";

import { getOperations, updateOperationStates } from "~/store/ducks/portalrh/actionTypes";
import Messages from "~/components/Messages";

const AnnexDocuments = ({ t }) => { 

  const { operations, isLoadingOperations } = useSelector(
    (state) => state.portalrhReducer
  );

  const dispatch = useDispatch();

  useEffect(() => {
    /*close full screen iframes*/
    closeIframesScreens();
  });

  
  useEffect(() => {
    dispatch(getOperations(t));
  }, []);

  const filteredOps = []
  operations.forEach((op) =>{
    if(op.active && op.processOperation && op.id != 6 && op.id != 10){
      filteredOps.push(op);
    }
  });

  function handleOperationCheckLists(){
    const checkList = []

    filteredOps.forEach((op) =>{
      checkList.push(
        <Form.Check 
          key={op.id}
          id={"opSwitch" + op.id}
          type="switch"
          label={op.name}
          defaultChecked={op.annexDoc}
        />
      )
    })
    
    return (<Form>{checkList}</Form>)
  }

  function updateAnnexDocumentConfigurations(){
    filteredOps.forEach((op) =>{
      op.annexDoc = (document.getElementById("opSwitch" + op.id).checked) ? 1 : 0
    })
    dispatch(updateOperationStates(filteredOps));
  }

  function revertAnnexDocumentConfigurations(){
    filteredOps.forEach((op) =>{
      document.getElementById("opSwitch" + op.id).checked = op.annexDoc;
    })
  }

  return (
    <>
      <div className="main-card-v2" style={{ width: "100%" }}>
        <Card
          bsPrefix="card-flat"
          style={{ minHeight: "80vh", overflow: "auto" }}
        >
          
          <Spinner spinning={isLoadingOperations.toString()} />
          
          <Card.Header className="justify-content-between">
            <h6 className="default-title">{t(`portalrh.annexDocs.title`)}</h6>
          </Card.Header>
          <Card.Body>
            
            <p>{t('portalrh.annexDocs.helpText')}</p>
            
            {handleOperationCheckLists()}
            
            <br/><br/>
            <Button variant="secondary" onClick={revertAnnexDocumentConfigurations}>
              {t("general.reset")}
            </Button>
            <Button  
              className="card-button" 
              onClick={updateAnnexDocumentConfigurations}
              style={{ marginLeft: "10px", marginRight: "55px" }}
            >
              {t("general.save")}
            </Button>
            <Messages />
          </Card.Body>
        </Card>
      </div>
    </>
  );
};
export default withNamespaces()(AnnexDocuments);